import { Tooltip, Typography } from '@mui/material';
import { IconTrash } from 'assets/img';
import type { Column } from 'react-table';
import { LwIconButton, TableCell, TableHeader, UserAvatar } from 'redesign';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import type { CellDefinition, ColumnDefinition } from '../flex-workers-table.types';

export const useGetFlexWorkersColumnDefinition = (): Record<
  Exclude<keyof ColumnDefinition, 'id'>,
  Column<ColumnDefinition>
> => {
  const { t } = useTranslation('ogp-screen-specific');

  return useMemo(
    () => ({
      userProfile: {
        accessor: 'userProfile',
        Header: '',
        Cell: (cell: CellDefinition<'userProfile'>) => {
          return (
            <UserAvatar
              onClick={() => cell.onShowFlexWorker(cell.row.original.id)}
              firstName={cell.value.firstName ?? ''}
              lastName={cell.value.lastName ?? ''}
              imageUrl={cell.value.imageUrl}
            />
          );
        },
      },
      name: {
        accessor: 'name',
        Header: () => (
          <TableHeader>
            {t('flexpools.fleworkers.table_headers.name', { ns: 'ogp-screen-specific' })}
          </TableHeader>
        ),
        Cell: ({ value }) => {
          return <TableCell>{value}</TableCell>;
        },
      },
      email: {
        accessor: 'email',
        Header: () => (
          <TableHeader>
            {t('flexpools.fleworkers.table_headers.email', { ns: 'ogp-screen-specific' })}
          </TableHeader>
        ),
        Cell: ({ value }) => (
          <TableCell>
            <a href={`mailto:${value}`}>{value}</a>
          </TableCell>
        ),
      },
      phone: {
        accessor: 'phone',
        Header: () => (
          <TableHeader>
            {t('flexpools.fleworkers.table_headers.phone', { ns: 'ogp-screen-specific' })}
          </TableHeader>
        ),
        Cell: ({ value }) => {
          return <TableCell>{value}</TableCell>;
        },
      },
      rating: {
        accessor: 'rating',
        Header: () => (
          <TableHeader>
            {t('flexpools.fleworkers.table_headers.rating', { ns: 'ogp-screen-specific' })}
          </TableHeader>
        ),
        Cell: ({ value }) => (value ? <Typography noWrap>{value}%</Typography> : null),
      },
      deleteAction: {
        accessor: 'deleteAction',
        Header: '',
        Cell: (cell: CellDefinition<'deleteAction'>) => (
          <Tooltip title="Verwijder">
            <LwIconButton
              color="default"
              iconColorMode="stroke"
              onClick={() => cell.onRemoveFlexWorker(cell.row.original.id)}
            >
              <IconTrash />
            </LwIconButton>
          </Tooltip>
        ),
      },
    }),
    [t]
  );
};
